import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Modal from '../Modal';
import * as modal from '../../reducers/modalReducer';

import './style.css';


class ProductAddedToCartModal extends Component {
    modalStyle = { border: `3px solid #${this.props.secondaryColor}` };

    onCloseRequest = () => {
      this.props.hideModal();
    }

    componentWillMount() {
      setTimeout(() => {
        this.onCloseRequest();
      }, 1000);
    }

    render() {
      const color = ['#', this.props.secondaryColor].join('');
      return (
        <Modal
          noOverlay
          overlayTop={0}
          style={this.modalStyle}
          paddingTop={250}
          closeOnOutsideClick
          isOpened
          onClose={this.onCloseRequest}
        >
          <ModalWrapperDiv>
            <HeaderDiv color={color}>ITEM ADDED TO CART</HeaderDiv>
          </ModalWrapperDiv>
        </Modal>
      );
    }
}

const mapStateToProps = state => ({
  primaryColor: state.config.primaryColor,
  secondaryColor: state.config.secondaryColor,
});

const mapDispatchToProps = dispatch => ({
  hideModal: () => dispatch(modal.hideModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductAddedToCartModal);

const ModalWrapperDiv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 10px auto 10px;
    height: 100%;
    font-family: 'Futura-Bold',  sans-serif;
`;
const HeaderDiv = styled.div`
    color: ${props => props.color};
    line-height: 36px;
    text-align: center;
    font-size: 28px;
    font-weight: 700; 
`;



// WEBPACK FOOTER //
// ./src/components/ProductAddedToCartModal/ProductAddedToCartModal.jsx